import React from 'react';
import { useAdverts } from 'src/contexts/advertisement';
import { Article } from 'src/services/articles';
import ArticleDetail from './ArticleDetail';
import ArticleList from '../List/ArticleList';
import Sidebar from 'src/components/Sidebar/Sidebar';
import InnerLayout from 'src/components/Layout/ContentLayout';

interface ArticleDetailPageProps {
  article: Article;
  relatedArticles: Article[] | undefined;
  recentArticles: Article[] | undefined;
}

export default function ArticleDetailPage({
  article,
  relatedArticles,
  recentArticles,
}: ArticleDetailPageProps) {
  const adverts = useAdverts();

  return (
    <InnerLayout
      main={<ArticleDetail article={article} />}
      sidebar={
        <Sidebar adverts={adverts}>
          {relatedArticles && !!relatedArticles.length && (
            <ArticleList title="Related Posts" articles={relatedArticles} />
          )}
          {recentArticles && !!recentArticles.length && (
            <ArticleList title="Recent Posts" articles={recentArticles} />
          )}
        </Sidebar>
      }
    ></InnerLayout>
  );
}
